import {
  GET_PROVIDER_CATALOG_REQUEST,
  GET_PROVIDER_CATALOG_SUCCESS,
  GET_PROVIDER_CATALOG_FAILURE,
  GET_PROVIDERS_REQUEST,
  GET_PROVIDERS_SUCCESS,
  GET_PROVIDERS_FAILURE,
  UPSERT_PROVIDER_REQUEST,
  UPSERT_PROVIDER_SUCCESS,
  UPSERT_PROVIDER_FAILURE,
  DELETE_PROVIDER_REQUEST,
  DELETE_PROVIDER_SUCCESS,
  DELETE_PROVIDER_FAILURE,
  GET_MODEL_BINDINGS_REQUEST,
  GET_MODEL_BINDINGS_SUCCESS,
  GET_MODEL_BINDINGS_FAILURE,
  UPSERT_MODEL_BINDING_REQUEST,
  UPSERT_MODEL_BINDING_SUCCESS,
  UPSERT_MODEL_BINDING_FAILURE,
  DELETE_MODEL_BINDING_REQUEST,
  DELETE_MODEL_BINDING_SUCCESS,
  DELETE_MODEL_BINDING_FAILURE,
  GET_AI_GATEWAY_PERMISSION_REQUEST,
  GET_AI_GATEWAY_PERMISSION_SUCCESS,
  GET_AI_GATEWAY_PERMISSION_FAILURE,
  GET_PROVIDER_MODELS_REQUEST,
  GET_PROVIDER_MODELS_SUCCESS,
  GET_PROVIDER_MODELS_FAILURE,
} from "./actions";
import { USER_LOGOUT_SUCCESS } from "../userLogin/actions";

const initialState = {
  catalog: { providers: [], capabilities: [] },
  providers: [],
  bindings: [],
  permission: null,

  catalogResult: { success: true },
  providersResult: { success: true },
  upsertProviderResult: { success: true },
  deleteProviderResult: { success: true },
  bindingsResult: { success: true },
  upsertBindingResult: { success: true },
  deleteBindingResult: { success: true },

  providerModels: {},
  providerModelsLoading: {},
  providerModelsSource: {}, // live | no-key | no-endpoint | freetext | error

  pending: 0,
  loading: true,
  error: null,
};

const startLoading = (state) => ({
  ...state,
  pending: state.pending + 1,
  loading: true,
});

const endLoading = (state, patch) => {
  const pending = Math.max(0, state.pending - 1);
  return { ...state, ...patch, pending, loading: pending > 0 };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_CATALOG_REQUEST:
    case GET_PROVIDERS_REQUEST:
    case UPSERT_PROVIDER_REQUEST:
    case DELETE_PROVIDER_REQUEST:
    case GET_MODEL_BINDINGS_REQUEST:
    case UPSERT_MODEL_BINDING_REQUEST:
    case DELETE_MODEL_BINDING_REQUEST:
    case GET_AI_GATEWAY_PERMISSION_REQUEST:
      return startLoading(state);

    case GET_PROVIDER_CATALOG_SUCCESS:
      return endLoading(state, { catalog: action.payload.catalog || initialState.catalog, catalogResult: { success: true } });
    case GET_PROVIDER_CATALOG_FAILURE:
      return endLoading(state, { catalogResult: { success: false, ...action.payload.error } });

    case GET_PROVIDERS_SUCCESS:
      return endLoading(state, { providers: (action.payload.providers && action.payload.providers.Items) || [], providersResult: { success: true } });
    case GET_PROVIDERS_FAILURE:
      return endLoading(state, { providersResult: { success: false, ...action.payload.error } });

    case UPSERT_PROVIDER_SUCCESS:
      return endLoading(state, { upsertProviderResult: { success: true } });
    case UPSERT_PROVIDER_FAILURE:
      return endLoading(state, { upsertProviderResult: { success: false, ...action.payload.error } });

    case DELETE_PROVIDER_SUCCESS:
      return endLoading(state, { deleteProviderResult: { success: true } });
    case DELETE_PROVIDER_FAILURE:
      return endLoading(state, { deleteProviderResult: { success: false, ...action.payload.error } });

    case GET_MODEL_BINDINGS_SUCCESS:
      return endLoading(state, { bindings: (action.payload.bindings && action.payload.bindings.Items) || [], bindingsResult: { success: true } });
    case GET_MODEL_BINDINGS_FAILURE:
      return endLoading(state, { bindingsResult: { success: false, ...action.payload.error } });

    case UPSERT_MODEL_BINDING_SUCCESS:
      return endLoading(state, { upsertBindingResult: { success: true } });
    case UPSERT_MODEL_BINDING_FAILURE:
      return endLoading(state, { upsertBindingResult: { success: false, ...action.payload.error } });

    case DELETE_MODEL_BINDING_SUCCESS:
      return endLoading(state, { deleteBindingResult: { success: true } });
    case DELETE_MODEL_BINDING_FAILURE:
      return endLoading(state, { deleteBindingResult: { success: false, ...action.payload.error } });

    case GET_AI_GATEWAY_PERMISSION_SUCCESS:
      return endLoading(state, { permission: action.payload.permission });
    case GET_AI_GATEWAY_PERMISSION_FAILURE:
      return endLoading(state, { permission: { canAdd: false, canView: false, canEdit: false, canDelete: false } });

    case GET_PROVIDER_MODELS_REQUEST:
      return { ...state, providerModelsLoading: { ...state.providerModelsLoading, [action.payload.provider]: true } };
    case GET_PROVIDER_MODELS_SUCCESS:
      return {
        ...state,
        providerModels: { ...state.providerModels, [action.payload.provider]: action.payload.models || [] },
        providerModelsSource: { ...state.providerModelsSource, [action.payload.provider]: action.payload.source || "live" },
        providerModelsLoading: { ...state.providerModelsLoading, [action.payload.provider]: false },
      };
    case GET_PROVIDER_MODELS_FAILURE:
      return {
        ...state,
        providerModels: { ...state.providerModels, [action.payload.provider]: [] },
        providerModelsSource: { ...state.providerModelsSource, [action.payload.provider]: "error" },
        providerModelsLoading: { ...state.providerModelsLoading, [action.payload.provider]: false },
      };

    case USER_LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
